(() => {
  if (customElements.get('product-group-selector')) return;
  customElements.define('product-group-selector', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const button = this.querySelector('[data-group-toggle]');
      button?.addEventListener('click', () => {
        if (this.animation) return;
        const strip = this.querySelector('[data-group-scroll]');
        const expanded = !this.hasAttribute('data-expanded');
        const animate = typeof strip.animate === 'function' && !matchMedia('(prefers-reduced-motion:reduce)').matches;
        const from = animate ? strip.offsetHeight : 0;
        this.toggleAttribute('data-expanded', expanded);
        button.setAttribute('aria-expanded', String(expanded));
        this.querySelector('[data-group-more]').hidden = expanded;
        this.querySelector('[data-group-less]').hidden = !expanded;
        if (!animate) return;
        const to = strip.offsetHeight;
        if (from === to) return;
        // Keep full rows rendered while the viewport closes over them.
        if (!expanded) this.setAttribute('data-expanded', '');
        const overflow = strip.style.overflow;
        strip.style.overflow = 'hidden';
        strip.inert = true;
        this.animation = strip.animate([{ height: from + 'px' }, { height: to + 'px' }], {
          duration: 220, easing: 'cubic-bezier(.2,0,0,1)',
        });
        const finish = () => {
          this.toggleAttribute('data-expanded', expanded);
          strip.style.overflow = overflow;
          strip.inert = false;
          this.animation = null;
        };
        this.animation.finished.then(finish, finish);
      }, options);
      const mobile = matchMedia('(max-width:749px)');
      const position = () => {
        if (!mobile.matches) return;
        const strip = this.querySelector('[data-group-scroll]');
        const offset = Number(this.dataset.activeOffset);
        if (strip && Number.isSafeInteger(offset) && offset > 0) {
          strip.scrollLeft = document.documentElement.dir === 'rtl' ? -offset : offset;
        }
      };
      // Fixed CSS item stride supplied by Liquid: no geometry reads or scroll listeners.
      position();
      mobile.addEventListener('change', position, options);
    }
    disconnectedCallback() { this.abort?.abort(); this.animation?.cancel(); }
  });
})();
